import React, { useState } from 'react';
import '../styles/Body.css';
import CreateScoreModal from './CreateScoreModal';
import ScoreCards from './ScoreCards';
import Toast from './Toast';
import ScoreFilterControls from './ScoreFilterControls';
import AdMaxUnit from './AdMaxUnit';
import { isAdEnabled } from '../utils/adVisibility';
import useLocale from '../hooks/useLocale';
import useUserPlan from '../hooks/useUserPlan';

const BODY_TEXT = {
  ja: {
    createScore: 'スコア作成',
    openComposer: '作曲モードを開く',
  },
  en: {
    createScore: 'Create Score',
    openComposer: 'Open Composer',
  },
};

const MAIN_ADMAX_SCRIPT_SRC =
  process.env.REACT_APP_ADMAX_MAIN_SCRIPT_SRC || 'https://adm.shinobi.jp/s/1eead92a44a0cd5197bf1acbf0fc0afe';
const FLOATING_ADMAX_SCRIPT_SRC =
  process.env.REACT_APP_ADMAX_FLOAT_SCRIPT_SRC || 'https://adm.shinobi.jp/s/846ed15a71b48898ad327071a7b5b168';

const Body = ({ isMenuOpen, user }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [toast, setToast] = useState(null);
  const [refreshKey, setRefreshKey] = useState(0);
  const locale = useLocale();
  const text = BODY_TEXT[locale] || BODY_TEXT.en;
  const userId = user?.uid || user?.sub || null;
  const { isPro, isLoading: isLoadingPlan } = useUserPlan(user);
  const canShowAds = isAdEnabled() && !isPro && (!userId || !isLoadingPlan);
  const canShowFloatingAd = Boolean(FLOATING_ADMAX_SCRIPT_SRC);

  const openModal = () => {
    if (!userId) {
      window.location.href = '/?mode=compose';
      return;
    }
    setIsModalOpen(true);
  };
  const closeModal = () => setIsModalOpen(false);

  const showToast = ({ title, message, variant = 'success' }) => {
    setToast({ title, message, variant });
  };

  const handleCreated = () => {
    setRefreshKey((prev) => prev + 1);
  };

  return (
    <>
      <div className={`body-container ${isMenuOpen ? 'shift-right' : ''}`}>
        <div className="score-content">
          <button className="create-score-button" onClick={openModal}>
            <span className="plus-icon">＋</span>
            {userId ? text.createScore : text.openComposer}
          </button>
          {userId ? (
            <>
              <ScoreFilterControls />
              {isModalOpen && (
                <CreateScoreModal
                  onClose={closeModal}
                  onNotify={showToast}
                  onCreated={handleCreated}
                />
              )}
              <ScoreCards
                onNotify={showToast}
                refreshKey={refreshKey}
                userId={userId}
              />
            </>
          ) : null}
          {canShowAds && (
            <section className="body-ad-slot" aria-label="Advertisement">
              <AdMaxUnit scriptSrc={MAIN_ADMAX_SCRIPT_SRC} title="AdMax Main Advertisement" />
            </section>
          )}
        </div>
      </div>
      {canShowAds && (
        <section
          className={`body-ad-slot-bottom-wrap ${isMenuOpen ? 'shift-right' : ''}`}
          aria-label="Bottom advertisement"
        >
          <div className="body-ad-slot body-ad-slot-bottom">
            <AdMaxUnit scriptSrc={MAIN_ADMAX_SCRIPT_SRC} title="AdMax Bottom Advertisement" />
          </div>
        </section>
      )}
      {canShowAds && canShowFloatingAd && (
        <section className="body-ad-slot-floating" aria-label="Floating advertisement">
          <AdMaxUnit
            scriptSrc={FLOATING_ADMAX_SCRIPT_SRC}
            title="AdMax Floating Advertisement"
            useIframe={false}
          />
        </section>
      )}
      {toast && (
        <Toast
          title={toast.title}
          message={toast.message}
          variant={toast.variant}
          onClose={() => setToast(null)}
        />
      )}
    </>
  );
};

export default Body;
